import { render, staticRenderFns } from "./BookingModal.vue?vue&type=template&id=2262f297"
import script from "./BookingModal.vue?vue&type=script&lang=js"
export * from "./BookingModal.vue?vue&type=script&lang=js"
import style0 from "./BookingModal.vue?vue&type=style&index=0&id=2262f297&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports